import { Icon, IconProps } from './Icon';

export type SpeedometerProps = IconProps;

export const Speedometer = (props: SpeedometerProps) => (
  <Icon width="20px" height="20px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="M18.333 10a8.333 8.333 0 0 1-16.666 0m16.666 0A8.333 8.333 0 0 0 10 1.667M18.333 10H16.25M1.666 10A8.333 8.333 0 0 1 10 1.667M1.667 10H3.75M10 1.667V3.75m5.899.417-4.65 4.583m4.65 7.149-.17-.17c-.577-.577-.865-.865-1.201-1.071a3.337 3.337 0 0 0-.964-.4c-.384-.091-.791-.091-1.607-.091H8.042c-.815 0-1.223 0-1.606.092a3.33 3.33 0 0 0-.964.399c-.336.206-.624.494-1.2 1.07l-.17.17m0-11.731 1.446 1.447M11.666 10a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
